module.exports = __webpack_public_path__ + "img/application.ad804f1d.svg";